import { FC, useState } from 'react';
import { Box, Flex, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger, Text } from '@chakra-ui/react';
import mixpanel from 'mixpanel-browser';
import { arcadeApiClient } from '../../../apiClients';
import { ICON_BY_NAME } from '../Icons/Icon';
import { CbButton } from '../Buttons/CbButton';
import { CbUserSelect } from 'ui/components/CbUserSelect';
interface CbSpectatorViewPopoverProps {
  initValue?: {};
  isMobile?: boolean;
  onAssumableUserChange?: (selectedOption: {}) => void;
  onResetClick?: () => void;
}
export const CbSpectatorViewPopover: FC<CbSpectatorViewPopoverProps> = ({
  initValue,
  isMobile = false,
  onAssumableUserChange = () => {},
  onResetClick = () => {}
}) => {
  const [assumedUser, setAssumedUser] = useState<any>(initValue);
  const handleAssumableUserChange: any = (selectedOption: {
    id: number;
    name: string;
  }) => {
    onAssumableUserChange(selectedOption);
    setAssumedUser(selectedOption);
    mixpanel.track('Spectator mode - user selected');
  };
  const handleResetClick: any = () => {
    onResetClick();
    setAssumedUser(null);
  };
  const fetchUsers = (inputValue: string) => arcadeApiClient.get(`multi_platform/manage/people/assumable?rows_per_page=10&page=0&query=${inputValue}`).then(res => res.data.people);
  return <Popover size={isMobile ? 'sm' : 'base'} isLazy data-sentry-element="Popover" data-sentry-component="CbSpectatorViewPopover" data-sentry-source-file="CbSpectatorViewPopover.tsx">
      <PopoverTrigger data-sentry-element="PopoverTrigger" data-sentry-source-file="CbSpectatorViewPopover.tsx">
        <Box as={'button'} backgroundColor="luigisPants.400" borderRadius="100px" paddingX={2} paddingY={1} height="29px" onClick={() => mixpanel.track('Spectator mode - clicked')} data-sentry-element="Box" data-sentry-source-file="CbSpectatorViewPopover.tsx">
          <Flex alignItems="center" justifyContent="center" paddingX={1} data-sentry-element="Flex" data-sentry-source-file="CbSpectatorViewPopover.tsx">
            <ICON_BY_NAME.people fontSize="16px" fill={assumedUser?.name ? 'white' : 'none'} data-sentry-element="unknown" data-sentry-source-file="CbSpectatorViewPopover.tsx" />
            {!!assumedUser && <Text fontSize="14px" color="cloud.100" marginLeft={2} noOfLines={1}>
                {assumedUser.name}
              </Text>}
          </Flex>
        </Box>
      </PopoverTrigger>
      <PopoverContent border="none" boxShadow="0px 20px 100px rgba(0, 0, 0, 0.2)" minWidth="206px" borderRadius={8} _focus={{
      boxShadow: '0px 20px 100px rgba(0, 0, 0, 0.2) !important',
      outline: 'none'
    }} data-sentry-element="PopoverContent" data-sentry-source-file="CbSpectatorViewPopover.tsx">
        <PopoverArrow boxShadow="none !important" data-sentry-element="PopoverArrow" data-sentry-source-file="CbSpectatorViewPopover.tsx" />
        <PopoverBody data-sentry-element="PopoverBody" data-sentry-source-file="CbSpectatorViewPopover.tsx">
          <CbUserSelect fetchUsers={fetchUsers} onChange={handleAssumableUserChange} value={assumedUser} data-sentry-element="CbUserSelect" data-sentry-source-file="CbSpectatorViewPopover.tsx" />
          <CbButton marginTop={2} size="sm" variant="outline" width="100%" onClick={handleResetClick} data-sentry-element="CbButton" data-sentry-source-file="CbSpectatorViewPopover.tsx">
            Reset
          </CbButton>
        </PopoverBody>
      </PopoverContent>
    </Popover>;
};